import classes from "./CartTypeButton.module.scss";

const CartTypeButton = ({ name, value, text, isChecked, onChanged }) => {
  let id = value.replace(/ /g, "");

  return (
    <div className={classes.CartType}>
      <input
        id={id}
        type="radio"
        name={name}
        value={value}
        checked={isChecked}
        onChange={() => onChanged(value)}
      />
      <label htmlFor={id}>{text}</label>
    </div>
  );
};

export default CartTypeButton;
